 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~6d6dcd74":"admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~6d6dcd74","admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~1a8cdaa9":"admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~1a8cdaa9","admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~aea77fe2":"admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~aea77fe2","admin-base-weight":"admin-base-weight","admin-companies":"admin-companies","admin-customers~admin-discount~admin-discounts~admin-products":"admin-customers~admin-discount~admin-discounts~admin-products","admin-customers":"admin-customers","admin-discount":"admin-discount","admin-discounts":"admin-discounts","admin-products":"admin-products","admin-images":"admin-images","admin-printers~admin-registers~admin-scales":"admin-printers~admin-registers~admin-scales","admin-printers":"admin-printers","admin-registers":"admin-registers","admin-scales":"admin-scales","admin-register-layouts":"admin-register-layouts","admin-shift":"admin-shift","admin-sidebar-menus":"admin-sidebar-menus","admin-stores":"admin-stores","admin-users":"admin-users","admin-vat-rates":"admin-vat-rates","admin-order":"admin-order","admin-shifts":"admin-shifts","admin-register-request-logs":"admin-register-request-logs","admin-index":"admin-index"}[chunkId]||chunkId) + "." + {"admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~6d6dcd74":"ffd1b226","admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~1a8cdaa9":"33865689","admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~aea77fe2":"8819a456","admin-base-weight":"f56391fd","admin-companies":"7b0a6098","admin-customers~admin-discount~admin-discounts~admin-products":"9bc46042","admin-customers":"fd2232a0","admin-discount":"b416fe7a","admin-discounts":"79f55d1e","admin-products":"0c21e7d9","admin-images":"8e4d1a8d","admin-printers~admin-registers~admin-scales":"9e6ca3e1","admin-printers":"09b50a10","admin-registers":"4c56dd88","admin-scales":"1af41057","admin-register-layouts":"d7406c64","admin-shift":"00f0f95d","admin-sidebar-menus":"1e37bc0b","admin-stores":"a6ea5b5d","admin-users":"e99296f8","admin-vat-rates":"72788624","admin-order":"452d6874","admin-shifts":"a4bad0f6","admin-register-request-logs":"69f0dc72","admin-index":"0d12cd9f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~6d6dcd74":1,"admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~1a8cdaa9":1,"admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~aea77fe2":1,"admin-base-weight":1,"admin-customers~admin-discount~admin-discounts~admin-products":1,"admin-customers":1,"admin-discount":1,"admin-discounts":1,"admin-products":1,"admin-printers~admin-registers~admin-scales":1,"admin-registers":1,"admin-register-layouts":1,"admin-shift":1,"admin-sidebar-menus":1,"admin-stores":1,"admin-users":1,"admin-vat-rates":1,"admin-order":1,"admin-register-request-logs":1,"admin-index":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~6d6dcd74":"admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~6d6dcd74","admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~1a8cdaa9":"admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~1a8cdaa9","admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~aea77fe2":"admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~aea77fe2","admin-base-weight":"admin-base-weight","admin-companies":"admin-companies","admin-customers~admin-discount~admin-discounts~admin-products":"admin-customers~admin-discount~admin-discounts~admin-products","admin-customers":"admin-customers","admin-discount":"admin-discount","admin-discounts":"admin-discounts","admin-products":"admin-products","admin-images":"admin-images","admin-printers~admin-registers~admin-scales":"admin-printers~admin-registers~admin-scales","admin-printers":"admin-printers","admin-registers":"admin-registers","admin-scales":"admin-scales","admin-register-layouts":"admin-register-layouts","admin-shift":"admin-shift","admin-sidebar-menus":"admin-sidebar-menus","admin-stores":"admin-stores","admin-users":"admin-users","admin-vat-rates":"admin-vat-rates","admin-order":"admin-order","admin-shifts":"admin-shifts","admin-register-request-logs":"admin-register-request-logs","admin-index":"admin-index"}[chunkId]||chunkId) + "." + {"admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~6d6dcd74":"6eb353c5","admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~1a8cdaa9":"2523d3f6","admin-base-weight~admin-companies~admin-customers~admin-discount~admin-discounts~admin-images~admin-~aea77fe2":"1adac357","admin-base-weight":"6ffb3d95","admin-companies":"31d6cfe0","admin-customers~admin-discount~admin-discounts~admin-products":"3a4871e2","admin-customers":"d4e5e668","admin-discount":"4d76039e","admin-discounts":"a3057fc2","admin-products":"e3c9dd91","admin-images":"31d6cfe0","admin-printers~admin-registers~admin-scales":"9621e906","admin-printers":"31d6cfe0","admin-registers":"e2cd55c1","admin-scales":"31d6cfe0","admin-register-layouts":"3d0f5dd3","admin-shift":"1c6a7e57","admin-sidebar-menus":"c6e567ea","admin-stores":"2146ee0f","admin-users":"a31349c8","admin-vat-rates":"b21443e2","admin-order":"998d4ace","admin-shifts":"31d6cfe0","admin-register-request-logs":"32a43235","admin-index":"6eb353c5"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
